/* Sitni dodaci koje tema trazi. Sve ostalo radi Shopify sam. */
(function () {
  // Galerija na strani artikla: klik na slicicu menja veliku sliku.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.thumbs button')
    if (!t) return
    var vel = document.querySelector('.stage img')
    var src = t.getAttribute('data-src')
    if (vel && src) {
      // srcset ima prednost nad src — bez ovoga slika se ne bi menjala
      vel.removeAttribute('srcset')
      vel.removeAttribute('sizes')
      vel.src = src
      document.querySelectorAll('.thumbs button').forEach(function (b) {
        b.setAttribute('aria-current', b === t ? 'true' : 'false')
      })
    }
  })

  // Kolicina na strani artikla: dugmad - i +
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.qty button[data-kol]')
    if (!b) return
    var polje = b.parentNode.querySelector('input')
    var n = parseInt(polje.value, 10)
    if (isNaN(n)) n = 1
    n = b.getAttribute('data-kol') === '+' ? n + 1 : n - 1
    polje.value = Math.max(1, n)
  })

  // Kolicina u korpi se salje bez pritiska na dugme.
  document.addEventListener('change', function (e) {
    if (e.target.matches('.korpa__red input[name="updates[]"]')) {
      e.target.closest('form').submit()
    }
  })

  // Osigurac: ako aplikacija (EasySell i slicne) ne ubaci svoje dugme
  // na karticu, vracamo ugradjeno — kartica ne sme da ostane bez nacina
  // da se poruci. Ceka se malo, jer aplikacija ubacuje posle ucitavanja.
  window.addEventListener('load', function () {
    window.setTimeout(function () {
      document.querySelectorAll('.kartica-dugmad--app').forEach(function (d) {
        var moje = d.querySelector('form > button')
        if (!moje) return
        var kartica = d.closest('.card') || d
        var tudje = 0
        // Aplikacija svoje dugme pravi kao <div class="es-popup-button">,
        // pa se mora traziti i po tome — inace se moje dugme vrati bez potrebe.
        kartica.querySelectorAll('button, a[role="button"], .es-popup-button, [class*="es-popup"], [class*="easysell"], [id*="easysell"]')
          .forEach(function (e) { if (e !== moje) tudje++ })
        if (tudje === 0) moje.style.display = 'block'
      })
    }, 3000)
  })

})()